export default __webpack_public_path__ + "static/media/logo.80acc903.png";